import React, { useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { AuthService } from 'services/AuthService/AuthService';

const Home = () => {
  const authService = useContext(AuthService);
  const history = useHistory();
  useEffect(() => {
    if (authService.isLoggedIn) {
      history.replace('/personal');
    }
  }, [authService.isLoggedIn, history]);

  return (<div />);
};

export default Home;
